import React from "react";
import './Logo.css';

function Logo() {
  return (
    <div className="logo">
      <img className="logo-img" src="/assets/svg/logo.svg" alt="Logo" />
      <h1 className="logo-title">ProfitOption</h1>
    </div>
  );
}

export default Logo;